import axios from 'axios';
import { Loading } from 'element-ui';
import router from '../router';

const instance = axios.create({
    // baseURL: 'http://yike.e-class.me/',
    // timeout: 3000
});

let loadingInstance = null;

/* 请求拦截器 */
instance.interceptors.request.use((config) => {
	loadingInstance =  Loading.service({
		lock: true,
		text: 'loading',
		spinner: 'el-icon-loading',
	});
	const token = localStorage.getItem('token') ? localStorage.getItem('token') : localStorage.getItem('sToken');
    if (token) {
        config.headers.Authorization = token;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

/* 响应拦截器 */

instance.interceptors.response.use((response) => {
	loadingInstance.close();
	if (response.data.code === 204) {
		router.push("/")
	}
    return response.data;
}, (error) => {
	loadingInstance.close();
    return Promise.reject(error);
});


const Http = {};

/* get方法参数以param对象传参 */
Http.axiosGetBy = (url, params, callback, reject) => {
    instance.get(url, {params: params}).then(callback).catch(reject);
}

/* get方法参数跟在url中 */
Http.axiosGet = (url, callback, reject) => {
    instance.get(url).then(callback).catch(reject);
}

/* post方法 */
Http.axiosPost = (url, params, callback, reject) => {
    instance.post(url, params).then(callback).catch(reject);
}

/* 上传文件 */
Http.axiosFile = (url, formData, callback, reject) => {
	let config = {
	        headers: {
	            'Content-Type': 'multipart/form-data'
	        }
	    }
	instance.post(url, formData, config).then(callback).catch(reject);
}

export default Http;
